import { registerComponent } from '@gig/magic-common';
import StaticPagesComponent from './static-pages.vue.js';

var StaticPages = registerComponent(StaticPagesComponent);

export { StaticPages };
